import { render, staticRenderFns } from "./custom-list.vue?vue&type=template&id=793af0a8&scoped=true"
import script from "./custom-list.vue?vue&type=script&lang=ts"
export * from "./custom-list.vue?vue&type=script&lang=ts"
import style0 from "./custom-list.vue?vue&type=style&index=0&id=793af0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793af0a8",
  null
  
)

export default component.exports